<div class="maintenance-wrapper">
  <div class="row">
    <img src="../../../assets/images/logo-white.svg" alt="">

    <img src="../../../assets/images/teachnav-settings-icon-active.svg" class="settings rotating" alt="">

    <div class="loading">
      <div translate>maintenance.loading</div>
      <span>.</span><span>.</span><span>.</span>
    </div>
  </div>
</div>